import React, { useState, useEffect } from "react";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { MultiCheckboxFacet, BooleanFacet } from "@elastic/react-search-ui-views";
import ClearFilters from "./ClearFilters";



import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  PagingInfo,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch,
  Results
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import {
  buildAutocompleteQueryConfig,
  buildSearchOptionsFromConfig,
  buildSortOptionsFromConfig,
  getConfig,
} from "./config/config-helper";


// import './style.min.css';
// import './LM-custom.min.css';

import './overWriteStyles.css';
import { Engine } from './Translate';

const { hostIdentifier, searchKey, endpointBase } = getConfig();



export default function App() {

  



  const domainNameRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/;

  
  const pathname = window.location.pathname;
  let lang = pathname.split('/')[1].split('?')[0];

  if(Engine[lang] === undefined){
    lang = 'us';
  }

  const engineName = Engine[lang].engineName;
  const data = Engine[lang];

  const connector = new AppSearchAPIConnector({
    searchKey,
    engineName,
    hostIdentifier,
    endpointBase
  });



  const config = {
    initialState: {
      resultsPerPage: 30
    },
    searchQuery: {
      disjunctiveFacets: ["brand", 'price_list', 'availability', 'cpu', 'gpu', 'display_size', 'panel_code', 'storage_ssd', 'storage_hdd', 'weight'],
      facets: {
        "availability": {
          "type": "range",
          "ranges": [
            { "from": 1, "to": 2, "name": `${data.availabilityLbl}` },
          ]
        },
        "brand": {
          "type": "value",
          "size": 50,
          "sort": { "count": "desc" }
        },
        "price_list": {
          "type": "range",
          "name": "price-list-ranges",
          "ranges": [
            { "from": 1, "to": data.price1, "name": `${data.under} ${data.curPrefix + data.price1 + data.curSufix}` },
            { "from": data.price1, "to": data.price2, "name": `${data.curPrefix + data.price1 + data.curSufix} - ${data.curPrefix + data.price2 + data.curSufix}` },
            { "from": data.price2, "to": data.price3, "name": `${data.curPrefix + data.price2 + data.curSufix} - ${data.curPrefix + data.price3 + data.curSufix}` },
            { "from": data.price3, "to": data.price4, "name": `${data.curPrefix + data.price3 + data.curSufix} - ${data.curPrefix + data.price4 + data.curSufix}` },
            { "from": data.price4, "name": `${data.over} ${data.curPrefix + data.price4 + data.curSufix}` }
          ]
        },
        "pop_searches": {
          "type": "value",
          "size": 10
        },
        "suitable_for": {
          "type": "value",
          "size": 10
        },
        "cpu": {
          "type": "value",
          "size": 750
        },
        "gpu": {
          "type": "value",
          "size": 750
        },
        "display_size": {
          "type": "range",
          "name": "display-size-ranges",
          "ranges": [
            { "from": 1, "to": 13, "name": `${data.upTo} 12"` },
            { "from": 12, "to": 14, "name": "12\" - 13\"" },
            { "from": 13, "to": 15, "name": "13\" - 14\"" },
            { "from": 15, "to": 17, "name": "15\" - 16\"" },
            { "from": 17, "name": `17" ${data.andLarger}` }
          ]
        },
        "panel_code": {
          "type": "range",
          "name": "panel-code-ranges",
          "ranges": [
            { "from": 1, "to": 2, "name": "TN" },
            { "from": 2, "to": 3, "name": "IPS" },
            { "from": 3, "to": 4, "name": "PLS" },
            { "from": 4, "to": 5, "name": "OLED" },
          ]
        },
        "storage_ssd": {
          "type": "range",
          "name": "storage-ssd-ranges",

          "ranges": [
            { "from": 1, "to": 257, "name": `${data.upTo} 256 GB` },
            { "from": 256, "to": 513, "name": "256 - 512GB" },
            { "from": 512, "to": 1023, "name": "512GB - 1TB" },
            { "from": 1024, "to": 2049, "name": "1TB - 2TB" },
            { "from": 2048, "to": 4097, "name": "2TB - 4TB" },
            { "from": 4096, "name": `${data.over} 4TB` }
          ]
        },

        "storage_hdd": {
          "type": "range",
          "name": "storage-hdd-ranges",
          "ranges": [
            { "from": 1, "to": 1023, "name": `${data.upTo} 1TB` },
            { "from": 1024, "to": 2049, "name": "1TB - 2TB" },
            { "from": 2048, "to": 4097, "name": "2TB - 4TB" },
            { "from": 4096, "name": `${data.over} 4TB` }
          ]


        },
        "ram": {
          "type": "range",
          "name": "ram-ranges",
          "ranges": [
            { "to": 9, "name": `${data.upTo} 8GB` },
            { "from": 8, "to": 18, "name": "8 - 16GB" },
            { "from": 16, "to": 33, "name": "16 - 32GB" },
            { "from": 32, "name": `32GB ${data.andMore}` },
          ]
        },
        "weight": {
          "type": "range",
          "name": "weight-ranges",
          "ranges": [
            { "to": 1.4, "name": data.weight1 },
            { "from": 1.4, "to": 2.4, "name": data.weight2 },
            { "from": 2.3, "to": 3.7, "name": data.weight3 },
            { "from": 3.6, "name": data.weight4 },
          ]
        }
      },
      "sort": [{
        "availability": "desc",
      },
    {
      "popularity_last30days": 'desc'
    }],

     

      ...buildSearchOptionsFromConfig()
    },
    autocompleteQuery: buildAutocompleteQueryConfig(),
    apiConnector: connector,
    alwaysSearchOnInitialLoad:  true
  };




  return (

    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ wasSearched, results, isLoading }) => ({ wasSearched, results, isLoading })}>

        {({ wasSearched, results, isLoading }) => {
          return (
            <div className="App">
              {/* { isLoading && 
                  <div style={loadAnim}>
                    <svg className="animate-spin text-white w-32" style={marginSvg} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" stroke="#f3f4f6" strokeWidth="4"></circle>
                      <path  fill="#02b7f4" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
              } */}
              
              <ErrorBoundary>
                
                <Layout
                  header={
                    <div>
                      <SearchBox autocompleteSuggestions={true} />
                      <ClearFilters/>
                    </div>
                }
                  sideContent={
                    <div>
                      {wasSearched && (
                        <Sorting
                          label={`${data.sortByLbl}`}
                          sortOptions={buildSortOptionsFromConfig()}

                        />
                      )}
                      { <Facet
                        field="availability"
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                        show={2}
                      />}
                      {<Facet
                        field="brand"
                        label={`${data.brandLbl}`}
                        isFilterable={true}
                        view={MultiCheckboxFacet}
                        filterType="any"
                        show={12}
                      />}
                      {!data.hidePrice && 
                        <Facet
                        field="price_list"
                        label={`${data.priceLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                        show={10}
                      />
                      }
                      <Facet
                        field="pop_searches"
                        label={`${data.popSrchLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="suitable_for"
                        label={`${data.suitForLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="cpu"
                        label={`${data.cpuLbl}`}
                        isFilterable={true}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="gpu"
                        label={`${data.gpuLbl}`}
                        isFilterable={true}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="ram"
                        label={`${data.ramLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="display_size"
                        label={`${data.displSizeLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="panel_code"
                        label={`${data.panelTypeLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                      <Facet
                        field="storage_ssd"
                        label={`${data.ssdLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                        show={10}
                      />
                      <Facet
                        field="storage_hdd"
                        label={`${data.hddLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                        show={10}
                      />
                      <Facet
                        field="weight"
                        label={`${data.weightLbl}`}
                        isFilterable={false}
                        view={MultiCheckboxFacet}
                        filterType="any"
                      />
                    </div>
                  }
                  bodyContent={
                    <ul>
                      {results.map(result => (
                        
                        <li className="flex items-center gap-2 list-none border-b py-1 mb-2" key={result?.id?.raw}>
                          <a href={result?.url?.raw} className="grid grid-cols-laptopLayoutSmall items-center gap-x-2 lg:grid-cols-laptopLayout w-full group">
                            <img className="w-20 sm:w-28 lg:h-28 object-contain row-span-6" src={result?.thumb?.raw} alt={result?.name?.raw} width="112" height="112"/>
                            <h2 className="group-hover:text-lm-lightOrange font-semibold text-lm-darkBlue mb-0.5 ml-1 text-base sm:text-lg lg:text-xl row-span-2 lg:row-span-1 col-start-2 row-start-3 lg:row-start-3">{result?.name?.raw}</h2>
                            <dl className="mt-2 lg:mt-0 flex items-center flex-wrap gap-1 text-gray-500 text-xs sm:text-sm lg:text-base col-span-2 lg:col-span-1 lg:row-start-4 lg:col-start-2">
                              <dt className="sr-only">Processor</dt><dd className="cpu">{result?.cpu?.raw}</dd>
                              <dt className="sr-only">Internal memory</dt><dd className="ram">{result?.ram?.raw}GB RAM</dd>
                              <dt className="sr-only">Video card</dt><dd className="gpu">{result?.gpu?.raw}</dd>
                              <dt className="sr-only">Display</dt>
                              <dd className="display">
                                {/* {result?.display_size?.raw}”, {result?.display_resolution?.raw}, {result?.panel_type?.raw} */}
                                {result?.display_name?.raw}
                              </dd>
                              {result?.storage_hdd?.raw > 0 && <React.Fragment><dt className="sr-only">Hard drive</dt><dd className="storage">{result?.storage_hdd?.raw}GB HDD</dd></React.Fragment>}
                              {result?.storage_ssd?.raw > 0 && <React.Fragment><dt className="sr-only">Solid-state drive</dt><dd className="storage">{result?.storage_ssd?.raw}GB SSD</dd></React.Fragment>}
                            </dl>
                          </a>
                          <div className="priceBtn w-28 lg:w-52 text-center flex-shrink-0">
                            <div className="priceAndDisctount mb-1">
                              {/* Формулата за процент ( ( Намалена цена - Стандартна цена) / Стандартна цена ) * 100 */}
                              {/* С !data.hidePrice правим проверка дали ключа hidePrice има добавена стойност true в Translate.js файла и ако е true, то тогава не показваме съдържанието */}
                              {result?.price_list?.raw > result?.price?.raw && !data.hidePrice &&
                              <React.Fragment>
                                <div className="listPrice mb-1 text-xs lg:text-sm text-gray-600">
                                  <span className="line-through">{data.curPrefix}{result?.price_list?.raw}{data.curSufix}</span>
                                  <span className="text-base lg:text-xl text-red-700 pl-1 font-semibold">
                                    {result?.price_list?.raw > result?.price?.raw && !data.hidePrice && 
                                    Math.floor(((result?.price?.raw - result?.price_list?.raw) / result?.price_list?.raw) * 100) + '%'}
                                  </span>
                                </div>
                              </React.Fragment>
                              }
                              <span className="text-xl lg:text-3xl font-bold">
                                {result?.price?.raw > 0 && !data.hidePrice &&
                                  <span className="text-lm-darkBlue">{data.curPrefix}{Math.floor(result?.price?.raw)}<sup>{(result?.price?.raw % 1).toFixed(2).substring(2)}</sup>{data.curSufix}</span>
                                }
                              </span>
                            </div>
                            <a href={result?.buy_url?.raw} className="block rounded-md py-0.5 text-slate-900 text-sm lg:text-lg border border-lm-darkOrange bg-lm-lightOrange hover:bg-lm-darkOrange mb-0.5" target="_blank">
                              {result?.price?.raw > 0 && !data.hidePrice ? `${data.avlbl}` : `${data.notAvlbl}`}
                            </a>
                            <span className="text-xs text-gray-600">
                              {/* Правим проверка дали домейна не е awin1.com, и ако е връщаме HP.com
                                  След това проверяваме дали домейна не е linksdirect.com и ако е връщаме Amazon.in
                                  Ако домейна не е някой от горните капитализираме първата буква на домейна */}
                              {result?.buy_url?.raw.match(domainNameRegex)[1] === "awin1.com" ? "HP.com" :
                               result?.buy_url?.raw.match(domainNameRegex)[1] === "linksredirect.com" ? "Amazon.in" : 
                               (result?.buy_url?.raw.match(domainNameRegex)[1]).charAt(0).toUpperCase() + (result?.buy_url?.raw.match(domainNameRegex)[1]).slice(1)
                              }
                              </span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  }
                  bodyHeader={
                    <React.Fragment>
                      {wasSearched && <PagingInfo
                        view={({ start, end, totalResults }) => (
                          <div>
                            Showing <strong>{start} - {end}</strong> out of <strong>{totalResults > 9999 ? '9999+' : totalResults}</strong>
                          </div>
                        )}
                      />}
                      {wasSearched && <ResultsPerPage options={[30, 50, 100]} />}
                    </React.Fragment>
                    
                  }
                  bodyFooter={<Paging />}
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
